import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { PatientJSONAModel } from "interfaces/jsona-models/PatientJSONAModel";

export class PatientSelector extends BaseApiSelector<PatientJSONAModel> {
  constructor() {
    super(ResourceType.Patient);
  }
}
